import { render, staticRenderFns } from "./bayi_tahsilat_detay.vue?vue&type=template&id=f455eaf4"
import script from "./bayi_tahsilat_detay.vue?vue&type=script&lang=js"
export * from "./bayi_tahsilat_detay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports